<template>
  <el-card>
    <el-button-group class="mb-3"><search-form :fields="search"/></el-button-group>

    <el-table :data="rebateLogs" resource="rebate-logs">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column align="center" header-align="center" label="账户" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <br />
            <span>{{ scope.row.user.idcard_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="log_type_text" label="类型" width="120" />
      <el-table-column prop="before_amount" label="变动前金额" width="100" />
      <el-table-column prop="amount" label="变动金额" width="100" />
      <el-table-column prop="after_amount" label="变动后金额" width="100" />
      <el-table-column prop="created_at" label="变动时间" width="170" />
      <el-table-column prop="order_id" label="订单号" width="190" />
      <el-table-column prop="remark" label="描述" />
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getRebateLogs } from '@/api/rebate-logs'

export default {
  name: 'UserRebateLogs',
  components: {
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        // 审核状态 0 余额兑换 1 提现 2 管理员修改 3 奖金结算 4 发货中心奖 5 报单 6 审核充值 7 等级升级报单 8 积分兑换 9 打款失败退回 10 基金分红
        {
          field: 'log_type',
          label: '类型',
          type: 'el-select',
          options: [
            { id: 0, name: '余额兑换' },
            { id: 1, name: '提现' },
            { id: 2, name: '管理员修改' },
            { id: 3, name: '奖金结算' },
            { id: 4, name: '发货中心奖' },
            { id: 5, name: '报单' },
            { id: 6, name: '审核充值' },
            { id: 7, name: '等级升级报单' },
            { id: 8, name: '积分兑换' },
            { id: 9, name: '打款失败退回' },
            { id: 10, name: '基金分红' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'order_id',
          label: '订单号',
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker',
        },
      ],
      rebateLogs: [],
      page: null,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        newVal.query.user_id = this.$route.params['id']
        const {
          data: { data, meta },
        } = await getRebateLogs(newVal.query)
        this.rebateLogs = data
        this.page = meta
      },
      immediate: true,
    },
  },
}
</script>
